import { isFeatureEnabledForActiveModule } from "./module_helper";

const displayedCaseReference = (record, fallback = "") => {
	if (!record) return fallback;

	const legacy = record.secondary_case_id || record.secondaryCaseId || fallback;

	if (!isFeatureEnabledForActiveModule("prefixed-case-references")) {
		return legacy;
	}

	return record.case_reference || record.caseReference || legacy;
}

export {
	displayedCaseReference,
};
